import React from 'react'
import {Flex as ChakraFlex, FlexProps} from '@chakra-ui/react'

export const Flex = (props: FlexProps) => {
  return <ChakraFlex {...props}></ChakraFlex>
}
export default Flex
